import type { CoverSheetConfigCard } from '../../types';

export const notesCard = {
  id: 'notes',
  innerTitle: 'Notes',
  fields: {
    notes: {
      name: 'notes',
      entity: 'interaction',
      type: 'textarea',
      label: 'Additional Info',
      placeholderText: 'Write your notes here',
    },
  },
} satisfies CoverSheetConfigCard;
